import { createSlice } from "@reduxjs/toolkit";

const initialState: string | null = null;

const featureSlice = createSlice({
  name: "feature",
  initialState,
  reducers: {
    setFeatureStore: (state: string | null, action: any | null) => {
      return action.payload;
    },
  },
});

export const { setFeatureStore } = featureSlice.actions;

export default featureSlice.reducer;